(function(angular){
    'use strict';

    angular.module('aprima-core-ui').component('apCachingSettings', {
        templateUrl: '/core-ui/component-views/ap-caching-settings.html',
        controllerAs: 'vm',
        controller: [
            '_',
            'AprimaCache',
            ApCachingSettings,
        ],
    });

    function ApCachingSettings(
        _,
        AprimaCache
    ) {
        var vm = this;

        vm.clearAll = clearAll;
        vm.totalSize = totalSize;

        function clearAll() {
            return AprimaCache.clearAll();
        }

        function totalSize() {
            var info = AprimaCache.info();
            if(!info) {
                return 0;
            }

            var size = _.reduce(info.caches, function(sum, cache) {
                var newSum = sum + ((cache && cache.size) || 0);
                return newSum;
            }, 0);

            return size;
        }
    }

})(window.angular);
